import { SelectItem } from "app/types/select-item";
import iGgr from "assets/img/ggr-token-icon.png";
import iPancakeSwap from "assets/img/PancakeSwap.png";
import iStoneFi from "assets/img/Ston.png";
import { FC } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Selector } from "../selector/selector";

enum SWAPPRES {
  PANCAKESWAP = "Pancake Swap",
  StoneFi = "StoneFi",
}

const LINKS = {
  [SWAPPRES.PANCAKESWAP]: "https://pancakeswap.finance/swap?inputCurrency=0x55d398326f99059fF775485246999027B3197955&outputCurrency=0xA90Da9e3c71DDFcC2D793F80029aCBd21A4A0Db6",
  [SWAPPRES.StoneFi]: "https://app.ston.fi/swap?chartVisible=false&ft=TON&tt=wGGR",
};

const ICONS = {
  [SWAPPRES.PANCAKESWAP]: iPancakeSwap,
  [SWAPPRES.StoneFi]: iStoneFi,
}

const SWAPPER_LIST = [
  {
    value: SWAPPRES.PANCAKESWAP,
    icon: ICONS[SWAPPRES.PANCAKESWAP],
  },
  {
    value: SWAPPRES.StoneFi,
    icon: ICONS[SWAPPRES.StoneFi],
  },
];

type Props = {};

// <Trans i18nKey="coinexPage.advantageDecentralizationText">
//   The CoinEx Smart Chain network <br /> supports up&nbsp;to&nbsp;101 validators
//   that are sorted and approved based on&nbsp;their CET token rate.
// </Trans>

const SwapperSelector: FC<Props> = () => {
  const { t, i18n } = useTranslation();

  const TITLE = {
    value: "",
    icon: iGgr,
    renderValue: <Trans i18nKey="Get GGR Now">
      {/* Get <span style={{ color: "#375fff" }}> GGR</span> Now */}
      Get <span style={{ color: "rgb(0 152 255)" }}> GGR</span> Now
    </Trans>,
  };

  const onSelectHandler = (selected: SelectItem) => {
    window.open(LINKS[selected.value as SWAPPRES], '_blank');
  };

  return (
    <Selector
      className="swapper-selector"
      selected={TITLE}
      list={SWAPPER_LIST}
      onSelect={onSelectHandler}
    />
  );
};

export default SwapperSelector;
